(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["inkrogue-home"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.ir-home').forEach((home) => {
  const buttons = home.querySelectorAll('[data-ir-sort]');
  const grid = home.querySelector('.ir-grid');
  if (!grid) return;
  buttons.forEach((button) => button.addEventListener('click', () => {
    buttons.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
    const products = Array.from(grid.querySelectorAll('[data-ir-order]'));
    products.sort((a, b) => button.dataset.irSort === 'desc' ? Number(b.dataset.irOrder) - Number(a.dataset.irOrder) : Number(a.dataset.irOrder) - Number(b.dataset.irOrder));
    products.forEach((product) => grid.append(product));
    const result = home.querySelector('.ir-result');
    if (result) result.textContent = `${products.length} designs · ${button.dataset.irSort === 'desc' ? 'highest' : 'lowest'} price first`;
  }));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
